import './Verse6.css';
import verse1 from '../assets/verse1.png';
import verse2 from '../assets/verse2.png';
import verse3 from '../assets/verse3.png';
import Space from './Space';

const Verse6 = () => {
    return (
        <div className="section verse-section">
            <img src={verse1} alt="Verse" className="image" />
            <h1 className="cDark w100 left">Above all,</h1>
            <h1 className="cDark w100 left">clothe yourselves with love,</h1>
            <h1 className="cDark w100 left">which binds us all together</h1>
            <h1 className="cDark w100 left">in perfect harmony.</h1>
            <Space s={24} />
            <img src={verse2} alt="Verse" className="image" />
            <img src={verse3} alt="Verse" className="image" />
            <p className="cDark w300 left">COLOSSIANS 3:14 NLT</p>
        </div>
    );
};

export default Verse6;
